var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlantFinderSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PottedPlant"
  }, /*#__PURE__*/React.createElement("path", {
    id: "MiddlePlantSprout",
    d: "M52.9084 49.8955C52.9084 49.8955 53.0971 36.307 52.9459 27.6858C52.7965 19.1752 57.8358 19.2872 59.5154 19.8098C61.5044 20.4286 64.4798 24.6996 60.4113 28.395",
    stroke: "#009426",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "RightPlantSprout",
    d: "M61.7552 49.7461C61.783 47.6839 61.88 43.3433 61.8671 41.4967C61.8451 38.3332 62.7662 36.0252 64.1215 34.604C66.7884 31.807 69.9536 31.3084 69.4983 28.3381",
    stroke: "#009426",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "LeftPlantSprout",
    d: "M45.6492 48.3281C45.6492 48.3281 45.7846 37.5955 45.7359 35.146C45.6926 32.9561 44.3051 30.5713 41.7249 30.8314",
    stroke: "#009426",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "MainPlantPot",
    d: "M34.9351 41.1463L72.9185 41.9555C72.9185 41.9555 68.673 66.8106 66.2933 76.4924C65.6751 79.0075 65.6212 80.3194 62.7604 80.5201C57.7509 80.8714 51.4857 80.7533 46.3983 80.3751C44.572 80.2392 43.2325 79.8976 42.5892 77.4363C39.9378 67.2914 34.9351 41.1463 34.9351 41.1463Z",
    fill: "#DF7132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PotDirt",
    d: "M38.2277 45.0155C30.4834 42.7207 34.0491 39.6771 38.078 38.1205C41.4258 36.8271 42.714 38.1867 43.9418 38.3388C44.8922 38.4563 44.9358 37.5205 46.4194 37.3304C47.6279 37.1754 47.8887 38.8333 48.6073 38.7413C49.4188 38.6376 49.314 37.6447 50.8488 37.6896C52.5765 37.7402 53.0247 38.4791 54.2271 38.5532C55.1273 38.6086 55.9096 37.4725 57.1518 37.418C58.3939 37.3638 59.081 38.5966 60.9246 38.2509C62.0124 38.047 62.6736 36.9829 64.594 36.6015C66.7682 36.1696 67.7698 36.3108 69.5054 37.108C71.3194 37.9418 72.065 38.417 72.3867 38.6048C73.4016 39.1969 76.8621 41.7188 73.1168 41.1712C70.8908 40.8457 69.0551 47.3004 69.0551 47.3004C69.0551 47.3004 45.9721 47.3106 38.2277 45.0155Z",
    fill: "#835D39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PotBottomShading",
    d: "M38.298 57.9428L36.1438 47.3004L72.3533 45.3826L70.0245 58.1968L38.298 57.9428Z",
    fill: "#CF692E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PotTopShading",
    d: "M37.4171 53.7094L36.1438 47.3004L72.3533 45.3826L70.8434 53.698L37.4171 53.7094Z",
    fill: "#C7652D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PlantPotTop",
    d: "M32.7721 39.694C33.9914 39.177 53.3282 39.1459 53.3282 39.1459C53.3282 39.1459 74.918 39.5022 75.6674 39.6621C76.7024 39.8833 76.6389 41.6511 76.5788 43.403C76.5196 45.1289 76.5006 47.0836 75.0328 47.3402C73.1894 47.6622 54.6671 47.8219 54.6671 47.8219C54.6671 47.8219 34.7988 47.5272 33.3431 47.2134C32.5312 47.0382 32.3385 45.017 32.1955 43.137C32.0528 41.2573 31.8352 40.091 32.7721 39.694Z",
    fill: "#EC7835"
  })), /*#__PURE__*/React.createElement("g", {
    id: "MagnifyingGlass"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SilverHandleConnector",
    d: "M73.3488 88.6729C73.3488 88.6729 74.5896 90.4509 76.1933 92.499C77.797 94.5475 79.7634 96.8657 81.2153 97.9465C81.6179 98.2459 82.3825 98.3994 83.0467 98.4782C83.7111 98.5567 84.2745 98.5606 84.2745 98.5606L83.9924 98.1621L83.1501 98.2251C83.1501 98.2251 86.5603 94.5349 89.9045 91.9321C93.2487 89.3291 97.7789 86.891 97.7789 86.891L97.5062 87.6662L97.9254 87.9803C97.9254 87.9803 97.962 87.3129 97.9606 86.5682C97.9591 85.8234 97.9198 85.0014 97.7681 84.692C96.9647 83.0546 95.2046 80.7032 93.6451 78.7614C92.0856 76.8196 90.7272 75.2874 90.7272 75.2874L86.9704 78.9633L83.2137 82.6392L78.2813 85.6559L73.3488 88.6729Z",
    fill: "#CCCCCC",
    stroke: "#BCBCBC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BrownMainHandle",
    d: "M84.2745 98.5606C84.2745 98.5606 86.9344 95.5011 90.3472 92.855C93.76 90.2089 97.9257 87.9768 97.9257 87.9768C97.9257 87.9768 106.44 96.6776 115.317 105.945C124.194 115.213 133.433 125.047 134.883 127.314C135.626 128.474 137.486 130.604 137.997 133.506C138.509 136.407 137.672 140.082 133.021 144.33C129.105 147.907 125.37 148.119 122.38 147.219C119.391 146.32 117.147 144.309 116.216 143.441C114.6 141.935 106.614 130.715 99.0331 119.871C91.4517 109.028 84.2745 98.5606 84.2745 98.5606Z",
    fill: "#C87137",
    stroke: "#BC6A34",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BrownHandleConnector",
    d: "M58.9556 90.4324C58.9556 90.4324 61.3216 91.4804 66.7043 91.8568C70.7054 92.1366 77.4097 91.8469 85.5627 85.101C92.9142 79.0184 94.1326 73.8958 94.6705 69.7081C95.1809 65.7372 94.3825 62.1187 94.3825 62.1187L79.6679 79.3441L58.9556 90.4324Z",
    fill: "#C87137",
    stroke: "#BC6A34",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "GlassMainLens",
    d: "M11.1414 44.5562C11.6843 23.5402 29.5471 5.46258 53.2192 5.46258C76.8914 5.46258 95.1343 23.4609 95.1343 47.7604C95.1343 72.0598 71.4753 90.0006 54.4919 88.8372C30.2309 87.1755 10.4852 69.9624 11.1414 44.5562Z",
    fill: "#00866F",
    fillOpacity: 0.0986395
  }), /*#__PURE__*/React.createElement("path", {
    id: "GlassLensShading1",
    d: "M31.7341 11.2228L46.9737 26.4779L56.1686 35.6728L65.3634 44.8676L74.5582 54.0624L83.753 63.2572L89.0745 68.4955C89.0745 68.4955 84.588 74.5063 84.5156 74.4343L84.3357 74.3142L78.624 68.3859L69.4292 59.1911L60.2344 49.9963L51.0396 40.8015L41.8447 31.6066L26.5579 16.2531L31.7341 11.2228Z",
    fill: "#00866F",
    fillOpacity: 0.0986395
  }), /*#__PURE__*/React.createElement("path", {
    id: "GlassLensDarkShading1",
    d: "M31.7341 11.2228L46.9737 26.4779L56.1686 35.6728L65.3634 44.8676L74.5582 54.0624L83.753 63.2572L89.0745 68.4955L88.1886 70.8984L30.1251 13.0019L31.7341 11.2228Z",
    fill: "#00866F",
    fillOpacity: 0.0986395
  }), /*#__PURE__*/React.createElement("path", {
    id: "GlassLensDarkShading2",
    d: "M56.027 5.61264L63.3041 12.8458L72.4989 22.0407L81.6937 31.2354L90.8886 40.4303L95.0297 44.5233L95.8509 45.5089L94.2902 46.9055L52.4959 5.16185L56.027 5.61264Z",
    fill: "#00866F",
    fillOpacity: 0.0986395
  }), /*#__PURE__*/React.createElement("path", {
    id: "GlassLensShading3",
    d: "M20.7984 21.0648L34.8867 35.2758L44.0815 44.4706L53.2764 53.6654L62.4712 62.8603L71.666 72.0551L78.997 79.0532L73.2984 83.9118L66.537 77.1841L57.3422 67.9893L48.1474 58.7944L38.9525 49.5996L29.7577 40.4048L16.2784 27.1158L20.7984 21.0648Z",
    fill: "#00866F",
    fillOpacity: 0.0986395
  }), /*#__PURE__*/React.createElement("path", {
    id: "GlassLensShading2",
    d: "M69.8312 7.34628C80.8802 11.9373 81.8572 13.6199 88.5437 22.7773C95.2304 31.9348 95.9985 35.095 96.5777 43.9758C97.1569 52.8562 92.814 59.3478 92.814 59.3478C92.2365 59.9253 93.1717 59.9253 92.5942 59.3478L40.4353 7.13681C39.8578 6.55939 41.2544 8.76161 41.8318 8.18417L46.3005 5.46105C46.8779 4.88361 58.7818 2.75524 69.8312 7.34628Z",
    fill: "#00866F",
    fillOpacity: 0.0986395
  }), /*#__PURE__*/React.createElement("path", {
    id: "GlassLensShading4",
    d: "M15.7192 30.9006L69.5763 84.7576C70.1537 85.3351 70.3181 84.5915 69.7406 85.1689L61.9198 86.906L11.9783 38.1249L15.8836 31.2296C16.4611 30.6521 15.1417 30.3231 15.7192 30.9006Z",
    fill: "#00866F",
    fillOpacity: 0.0986395
  }), /*#__PURE__*/React.createElement("path", {
    id: "GlassLensShading5",
    d: "M59.7053 88.137C54.525 90.1928 52.1651 90.2051 40.6333 85.7443C29.1012 81.2836 25.2778 79.9682 18.3504 68.5594C11.4229 57.1509 12.5718 39.7684 11.8502 40.49C11.1287 41.2116 59.7053 88.137 59.7053 88.137Z",
    fill: "#00866F",
    fillOpacity: 0.0986395
  }), /*#__PURE__*/React.createElement("path", {
    id: "GlassLensDarkShading5",
    d: "M47.5682 87.7904C42.3879 89.8459 52.1651 90.2051 40.6333 85.7443C29.1012 81.2836 25.2778 79.9682 18.3504 68.5594C11.4229 57.1509 12.8492 52.3219 12.1276 53.0435C11.4061 53.765 47.5682 87.7904 47.5682 87.7904Z",
    fill: "#00866F",
    fillOpacity: 0.0986395
  }), /*#__PURE__*/React.createElement("path", {
    id: "GlassLensHighlight1",
    d: "M83.9698 57.5068L79.1937 52.644M75 48.5L64.5 38M60.8819 34L47 20",
    stroke: "white",
    strokeOpacity: 0.248299,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "GlassLensHighlight2",
    d: "M29.719 25.1057L40 35.3444M44.6748 40L65.5 60.7396",
    stroke: "white",
    strokeOpacity: 0.248299,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "GlassLensHighlight3",
    d: "M54.7743 13.5969L63.4267 22.5M69.2577 28.5L83.5 43.1551",
    stroke: "white",
    strokeOpacity: 0.248299,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "GlassLensHighlight4",
    d: "M57.7354 77.9751L51.1226 71.5M44.7856 65.2949L30.6974 51.5L28.5 49.3484L26.1017 47",
    stroke: "white",
    strokeOpacity: 0.248299,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "GlassLensHighlight5",
    d: "M44.5 85.5L34 75.5M28.6839 70.2949L14.5957 56.5L12.3983 54.3484L10 52",
    stroke: "white",
    strokeOpacity: 0.248299,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "GlassLensHighlight6",
    d: "M93.6839 37.2949L79.5957 23.5L77.3983 21.3484L75 19",
    stroke: "white",
    strokeOpacity: 0.248299,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "MagnifyingGlassMiddleMetal",
    d: "M11.1414 44.5562C11.6843 23.5402 29.5471 5.46258 53.2192 5.46258C76.8914 5.46258 95.1343 23.4609 95.1343 47.7604C95.1343 72.0598 71.4753 90.0006 54.4919 88.8372C30.2309 87.1755 10.4852 69.9624 11.1414 44.5562Z",
    stroke: "#CDCDCD",
    strokeWidth: 5.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "MagnifyingGlassOutsideMetal",
    d: "M8.85864 46.7235C8.85864 22.6405 28.7684 3.11739 53.3282 3.11739C77.8881 3.11739 97.7977 22.6405 97.7977 46.7235C97.7977 70.8064 78.5766 91.05 54.0167 91.05C29.4568 91.05 8.85864 70.8064 8.85864 46.7235Z",
    stroke: "#BDBDBD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "MagnifyingGlassInsideMetal",
    d: "M13.9219 46.2709C13.1196 27.7289 29.6332 8.04062 53.2649 8.04062C76.8964 8.04062 92.4015 26.2571 92.0309 48.3091C91.6245 72.4896 68.7741 86.5761 53.3933 86.02C30.0349 85.176 14.7558 65.5433 13.9219 46.2709Z",
    stroke: "#BDBDBD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "MiddleMetalHighlight",
    d: "M11.4446 43.8469C11.5426 41.4155 11.8611 39.1356 12.3435 37.0066C12.8259 34.8779 13.4721 32.9004 14.2255 31.0743C14.9789 29.2483 15.8395 27.5738 16.7506 26.0511C17.6617 24.5283 18.6234 23.1572 19.5789 21.9381C20.5344 20.719 21.4838 19.6519 22.3705 18.7369C23.2571 17.8219 24.0809 17.0591 24.7853 16.4487C25.4897 15.8383 26.0746 15.3802 26.4835 15.0748C26.8923 14.7694 27.1251 14.6165 27.1251 14.6165",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BottomMetalHighlight",
    d: "M23.431 75.8106C23.431 75.8106 23.2321 75.598 22.8856 75.1898C22.5391 74.7817 22.0448 74.1782 21.4541 73.3966C20.8633 72.6152 20.176 71.6555 19.4433 70.5352C18.7107 69.4151 17.9326 68.134 17.1603 66.7099C16.388 65.2855 15.6216 63.7178 14.912 62.0241C14.2025 60.3305 13.5498 58.5108 13.0053 56.5822C12.4608 54.6539 12.0243 52.6169 11.7472 50.4885",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TopMetalHighlight",
    d: "M30.9264 12C37.5 8.07396 41.2767 7.07367 47.1812 5.87429",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlantFinderSvg);
export default __webpack_public_path__ + "static/media/PlantFinderSVG.14020f6b9e408e101b0104a2dcd597b6.svg";
export { ForwardRef as ReactComponent };